import { Box, CircularProgress } from '@material-ui/core';

function Loading() {
  return (
    <Box
      height="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      data-testid="loading-container"
    >
      <CircularProgress data-testid="loading-indicator" />
    </Box>
  );
}

export default Loading;
